import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Serverless computing?",
    answer: `<p>Serverless computing is a means of offering backend services on an as-needed basis. While servers are still used, a company that receives backend services from a serverless vendor is charged based on consumption rather than a fixed amount of bandwidth or the number of servers.</p>`,
  },
  {
    question: "What is the difference between serverless and cloud computing?",
    answer: `<p>A cloud-native solution extracts infrastructure to the operating system level, whereas serverless computing extends the extraction to encompass containerized workloads. Both abstract away the underlying hardware and create dynamic pools of resources for developers to use.</p>`,
  },
  {
    question: "Is serverless computing SAAS or PaaS?",
    answer: `<p>Serverless computing is quite similar to PaaS solutions. Serverless solutions, on the other hand, allow developers to construct apps that scale themselves without the need to manage backend infrastructure or server resources.</p>`,
  },
  {
    question: "What are serverless computing services?",
    answer: `<p>It allows developers to create apps faster by minimizing the need for them to manage infrastructure. However, with serverless apps, the cloud service providers automatically manage and scale the infrastructure needed to run the code.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Serverless Computing Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
